<template>
  <generic-container
    icon="visa"
    :title="$t('visalink links')"
    :configurable="true"
    :show_plus="true"
    v-bind:configure_modal="configure_modal"
    @add="add"
    :show_refresh="true"
    @refresh="init"
    :header_buttons="header_buttons"
  >
    <table
      class="ui blue very compact celled striped selectable table"
      ref="table"
      style="width: 100%"
    >
      <thead>
        <tr>
          <th>{{ $t("date") }}</th>
          <th>{{ $t("promissory note") }}</th>
          <th>{{ $t("quota") }}</th>
          <th>{{ $t("message") }}</th>
          <th>{{ $t("links") }}</th>
        </tr>
      </thead>
      <tbody></tbody>
    </table>
    <link-modal ref="link_modal" @success="init" @deleted="init" />
  </generic-container>
</template>

<script>
import filters from "@/filters";
import {
  // local_api,
  init_ajax_data_datables,
  enterprise_setup,
  success_toast,
} from "@/utils";
import GenericContainer from "@/components/GenericContainer";
import ConfigureModal from "./configuration_modal/Index.vue";
import LinkModal from "./link_modal/Index.vue";
import copy from "copy-to-clipboard";

// @ is an alias to /src
export default {
  name: "OnfidoConnectIndex",
  components: {
    "generic-container": GenericContainer,
    LinkModal,
  },
  filters: filters,
  data() {
    return {
      configure_modal: ConfigureModal,
      datatable: {},
      header_buttons: [
        {
          icon: "cubes",
          click: this.go_bulk,
          tooltip: this.$t("bulk process"),
        },
      ],
    };
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    // get_verifications() {
    //   let vm = this;
    //   let ent_setup = enterprise_setup(vm);
    //   local_api(vm, "post", "/shortio/link/do-get-list", {
    //     s: vm.start_date,
    //     e: vm.end_date,
    //   })
    //     .then((verifications) => {
    //       vm.verifications = verifications;

    //       let columns = [
    //         {
    //           data: function(row) {
    //             // console.log(row);
    //             return filters.formatDate(
    //               row.create_date,
    //               ent_setup.detailed_date_format,
    //             );
    //           },
    //         },
    //         {
    //           data: function(row) {
    //             return JSON.stringify(row);
    //           },
    //         },
    //       ];
    //       let onSelect = function(data) {
    //         vm.show_verification_modal = true;
    //         setTimeout(() => {
    //           vm.$refs.verification_modal.updateVerification(data.uuid);
    //         }, 200);
    //       };
    //       let onCreatedRow = (tr, data) => {
    //         let $tr = window.jQuery(tr);
    //         if (data.check_result == "clear") {
    //           $tr.addClass("positive");
    //         } else if (data.check_result == "consider") {
    //           $tr.addClass("warning");
    //         }
    //       };

    //       init_json_local_data_datables(
    //         vm,
    //         vm.$refs.table,
    //         verifications,
    //         columns,
    //         onSelect,
    //         onCreatedRow,
    //         null,
    //       );
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //       vm.$alertify.error(stringify(err));
    //     });
    // },
    add() {
      let vm = this;
      vm.$refs.link_modal.show_modal();
    },
    init() {
      let vm = this;
      let columns = [
        {
          data: function (row) {
            return filters.formatDate(
              row.create_date,
              vm.enterprise_setup.detailed_date_format,
            );
          },
        },
        {
          data: function (row) {
            return row.promissory_note;
          },
        },
        {
          data: function (row) {
            return filters.formatCurrency(
              row.quota,
              vm.enterprise_setup.currency_iso,
            );
          },
        },
        {
          data: function (row) {
            return row.message;
          },
        },
        {
          data: function (row) {
            let itms = row.link.reduce((prev, curr) => {
              return `${prev}<div class="item">${curr.nombre}: <a href="#" onclick="window.dispatchEvent(new CustomEvent('copy_link', { detail: { url: '${curr.short_url}'}}))">${curr.short_url}</a></div>`;
            }, "");
            return `<div class="ui bulleted list">${itms}</div>`;
          },
        },
      ];

      let onSelect = (data) => {
        // console.log(data);
        vm.$refs.link_modal.show_modal(data);
      };

      vm.datatable = init_ajax_data_datables(
        vm,
        vm.$refs.table,
        window.jQuery.fn.api.settings.api["visalink generator url"],
        columns,
        onSelect,
      );
    },
    go_bulk() {
      this.$router.push({ name: "VisalinkGeneratorBulkIndex", replace: true });
    },
  },
  created() {
    let vm = this;
    window.addEventListener(
      "copy_link",
      function (e) {
        let url = e.detail.url;
        copy(url);
        success_toast(vm.$t("url copied to clipboard"));
      },
      false,
    );
  },
  mounted() {
    let vm = this;
    // setTimeout(() => {
    vm.init();
    // }, 500);
    // window.jQuery(vm.$refs.range_start).calendar({
    //   today: true,
    //   type: "datetime",
    //   endCalendar: window.jQuery(vm.$refs.range_end),
    //   onSelect(value) {
    //     vm.start_date = value;
    //   },
    // });
    // window.jQuery(vm.$refs.range_end).calendar({
    //   today: true,
    //   type: "datetime",
    //   startCalendar: window.jQuery(vm.$refs.range_start),
    //   onSelect(value) {
    //     vm.end_date = value;
    //   },
    // });
  },
  watch: {},
};
</script>
